import { ChangeDetectionStrategy, Component, Input } from '@angular/core';

import { IUser } from 'user/user';

@Component({
	selector: 'spr-user-metadata',
	templateUrl: './user-metadata.component.html',
	changeDetection: ChangeDetectionStrategy.OnPush,
	host: {
		class:
			'p-background-color-primary-pastel flex md:flex-row md:space-y-0 space-y-3 flex-col items-start md:p-7 py-7 px-4',
	},
})
export class UserMetadataComponent {
	@Input() public user: IUser;
	@Input() public locale: string;
}
